import Loading from '../../components/Loading/Loading';
import BarChartLoader from '../ServicesReports/BarChartLoader';

const URLGraphLoader = (props: any) => {
  const { isLoading } = props;
  return (
    <div
      style={{
        // position: 'relative',
        height: '259px',
        width: '91%',
        margin: '5rem auto',
      }}
    >
      {/* Y-axis line */}
      <div
        style={{
          // position: 'absolute',
          top: 0,
          left: '0%',
          width: '1px',
          height: '100%',
          background: 'black',
          transform: 'translateX(-50%)',
        }}
      />

      {/* X-axis line */}
      <div
        style={{
          // position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '1px',
          background: 'black',
        }}
      />

      {/* Centered content */}
      <div
        style={{
          position: 'absolute',
          top: '58%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {/* Your content */}
        {/* ... */}
        {isLoading ? <Loading style={{ height: '200px' }} /> : 'No Data Found'}
      </div>
    </div>
  );
};

export default URLGraphLoader;
